import * as validations from '../../../validations.js'

export default function ({config}) {
  return {
    pastGuestBenefit: validations.ensure(
      config.errorMessages.pastGuestBenefit,
      (value, is, object) => {
        return (
          value === false ||
          object.passengers.some(p => p.pastGuestBenefit.selected)
        )
      }
    ),
  }
}
